import axios from "axios";

type CompetitorPayload = {
  conversation: {
    role: string;
    content: string;
  }[];
  query: string;
  userId?: number;
};


type CompetitorSuggestionsPayload = {
  query: string;
  service_name?: string;
};


type CompetitorFeedbackPayload = {
  questionId: number;
  request: string;
  response: string;
  feedBack: boolean;
  displayType: string;
}

type competitorGetChatHistoryPayload = {
  service_name: string;
  userID: number;
}

export const competitorChatbot = async (payload: CompetitorPayload, reportType: string) => {
  if (reportType === "annual") {
    const response = await axios.post(
      process.env.REACT_APP_BASE_URL + "/user-message",
      payload
    )
    return response.data;
  }
  else {
    const response = await axios.post(
      process.env.REACT_APP_BASE_URL + `/${reportType}/user-message`,
      payload
    )
    return response.data
  }
};
export const competitorSuggestions = async (payload: CompetitorSuggestionsPayload, reportType: string) => {
  if (reportType === "annual") {
    const response = await axios.post(
      process.env.REACT_APP_BASE_URL + "/suggestion",
      payload
    );
    return response.data;
  }
  const response = await axios.post(
    process.env.REACT_APP_BASE_URL + `/${reportType}/suggestion`,
    payload
  )
  return response.data
}

export const competitorFeedback = async (payload: CompetitorFeedbackPayload, reportType: string) => {
  if (reportType === "annual") {
    const response = await axios.post(
      process.env.REACT_APP_BASE_URL + "/feedback",
      payload
    );
    return response.data;
  }
  const response = await axios.post(
    process.env.REACT_APP_BASE_URL + `/${reportType}/feedback`,
    payload
  )
  return response.data
}

export const competitorGetChatHistory = async (payload: competitorGetChatHistoryPayload, reportType: string) => {
  if (reportType === "annual") {
    const response = await axios.post(
      process.env.REACT_APP_BASE_URL + "/get_chat_history",
      payload
    );
    return response.data;
  }
  const response = await axios.post(
    process.env.REACT_APP_BASE_URL + `/${reportType}/get_chat_history`,
    payload
  )
  return response.data
}